import './TeamBox.css';
import { getFinalPointsColor } from '../../utils/playerHelpers';

const TeamBox = ({
  teamIndex,
  config,
  draftedPlayers,
  editingTeamName,
  isActive,
  teamProjected,
  teamFinal,
  onTeamNameEdit,
  onEditStart,
  onEditEnd,
  renderPositionFields
}) => {
  return (
    <div
      className={`team-box ${isActive ? 'active-turn' : ''}`}
      id={`team-${teamIndex}`}
    >
      <h3>
        {editingTeamName === teamIndex ? (
          <input
            type="text"
            value={config.teamNames[teamIndex] || ''}
            onChange={(e) => onTeamNameEdit(teamIndex, e.target.value)}
            onBlur={onEditEnd}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onEditEnd();
              }
            }}
            autoFocus
            className="team-name-edit"
          />
        ) : (
          <span
            className="team-name"
            onClick={() => onEditStart(teamIndex)}
          >
            {config.teamNames[teamIndex] ?
              `${config.teamNames[teamIndex]} (Team ${teamIndex + 1})` :
              `Team ${teamIndex + 1}`}
          </span>
        )}
        <span className="team-projected">
          ({teamProjected})
          {teamFinal !== null && (
            <strong
              className="team-final-points"
              style={{ color: getFinalPointsColor(parseFloat(teamFinal), parseFloat(teamProjected)) }}
            > ({teamFinal})</strong>
          )}
        </span>
      </h3>
      {renderPositionFields(teamIndex)}
    </div>
  );
};

export default TeamBox;
